import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/en/coverBanner.vue";
import Home_ar from "../views/ar/coverBanner.vue";
import i18n from '../i18n';
Vue.use(VueRouter);

const routes = [{
        path: "/",
        redirect: `/${i18n.locale}`
    },
    {
        path: "/:lang",
        component: {
            render(c) {
                return c("router-view");
            }
        },
        children: [{
                path: "/",
                name: "Home",
                component: () =>
                    import ("../views/" + i18n.locale + "/coverBanner.vue")
            },
            {
                path: "tableContents",
                name: "tableContents",
                component: () =>
                    import ("../views/" + i18n.locale + "/tableOfContents.vue")
            },
            {
                path: "viceChairman-message",
                name: "viceChairman-message",
                component: () =>
                    import ("../views/" + i18n.locale + "/viceChairmanMsg.vue")
            },
            {
                path: "sustainabilityOfficer-message",
                name: "sustainabilityOfficer",
                component: () =>
                    import ("../views/" + i18n.locale + "/sustainabilityOfficerMsg.vue")
            },
            {
                path: "introduction",
                name: "introduction",
                component: () =>
                    import ("../views/" + i18n.locale + "/introduction.vue")
            },
            {
                path: "aspects-of-gender-disparity",
                name: "aspects-of-gender-disparity",
                component: () =>
                    import ("../views/" + i18n.locale + "/aspectsOfGenderDisparity.vue")
            },
            {
                path: "gender-digital-divide",
                name: "gender-digital-divide",
                component: () =>
                    import ("../views/" + i18n.locale + "/genderDigitalDivide.vue")
            },
            {
                path: "literacy-and-stem-education",
                name: "literacy-and-stem-education",
                component: () =>
                    import ("../views/" + i18n.locale + "/lityrasiAndStemEducation.vue")
            },
            {
                path: "employment-equality",
                name: "employment-equality",
                component: () =>
                    import ("../views/" + i18n.locale + "/employmentEquality.vue")
            },
            {
                path: "gender-biasis-in-stem",
                name: "gender-biasis-in-stem",
                component: () =>
                    import ("../views/" + i18n.locale + "/genderBiasisInStem.vue")
            },
            {
                path: "innovation-in-stem",
                name: "innovation-in-stem",
                component: () =>
                    import ("../views/" + i18n.locale + "/innovationInStem.vue")
            },
            {
                path: "Developing-stem-skills-to-achieve-financial-inclusion",
                name: "Developing-stem-skills-to-achieve-financial-inclusion",
                component: () =>
                    import ("../views/" + i18n.locale + "/financialInclusion.vue")
            },
            {
                path: "covid-19-and-women-in-technology",
                name: "covid-19-and-women-in-technology",
                component: () =>
                    import ("../views/" + i18n.locale + "/womenInTechnology.vue")
            },
            {
                path: "conclusion",
                name: "conclusion",
                component: () =>
                    import ("../views/" + i18n.locale + "/conclusion.vue")
            }
        ]
    },

];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        // if (savedPosition) {
        //     return savedPosition
        // } else {
        //     return { x: 0, y: 0 }
        // }
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({ x: 0, y: 0 });
            }, 500);
        });
    }
});

export default router;